import { generatePath, Link as ReactLink } from 'react-router-dom';
import React from 'react';

const paths = {
  studyplan: '/studyplan/:studyplan',
  get start() {
    return `${this.studyplan}/start`;
  },
  get semester() {
    return `${this.studyplan}/semester/:semester`;
  },
  get compulsory() {
    return `${this.semester}/compulsory`;
  },
  get info() {
    return `${this.studyplan}/info/:module`;
  },
  get overview() {
    return `${this.studyplan}/overview`;
  },
};

const getPath = (path, params) => {
  if (params) {
    return generatePath(paths[path], params);
  } else if (paths[path] !== undefined) {
    return paths[path];
  } else {
    return path;
  }
};

class Link extends React.Component {
  render() {
    const params = {
      ...this.props,
      to: getPath(this.props.to, this.props.params),
    };
    return <ReactLink {...params} />;
  }
}

export default Link;

export { paths, getPath };
